import React from 'react';
import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="head">
      <h1>Argon.sh</h1>

      <p>"The future of marketing"</p>
    </div>
  );
}

export default App;
